module.exports = __webpack_public_path__ + "img/142.8.04060651.png";